const confirm = () => import('../views/other-author/confirm')
const decline = () => import('../views/other-author/decline')
const notice = () => import('../views/other-author/notice')
const unable = () => import('../views/other-author/unable')
const privacyPolicy = () => import('../views/privacy-policy')
const confirmReview = () => import('../views/email-url/review-confirm')
const emailUrl = () => import('../views/email-url')
const reviewAgree = () => import('../views/email-url/reviewer-agree')
const reviewRefuse = () => import('../views/email-url/refuse-review')
const reviewView = () => import('../views/email-url/review-result')
const academicAgree = () => import('../views/email-url/academic-agree')
const authorRevise = () => import('../views/email-url/author-revise')
const authorReviseReply = () =>
  import('../views/email-url/author-revise/replay')
const invalidPage = () => import('../views/email-url/invalid-page')
const page404 = () => import('../views/404')
export default [
  {
    path: '/other-author/confirm/:id',
    component: confirm,
    name: '/other-author/other-author/confirm'
  },
  {
    path: '/other-author/decline/:id',
    component: decline,
    name: '/other-author/other-author/decline'
  },
  {
    path: '/other-author/notice/:id',
    component: notice,
    name: '/other-author/other-author/notice'
  },
  {
    path: '/other-author/unable',
    component: unable,
    name: '/other-author/other-author/unable'
  },
  {
    path: '/privacy-policy',
    component: privacyPolicy,
    name: '/privacy-policy'
  },
  {
    path: '/email-url',
    component: emailUrl,
    name: '/email-url',
    children: [
      // 审稿人审稿确认页面
      {
        path: '/email-url/review-confirm',
        component: confirmReview,
        name: '/email-url/review-confirm'
      },
      {
        path: '/email-url/review-agree',
        component: reviewAgree,
        name: '/email-url/review-agree'
      },
      {
        path: '/email-url/review-refuse',
        component: reviewRefuse,
        name: '/email-url/review-refuse'
      },
      {
        path: '/email-url/review-view',
        component: reviewView,
        name: '/email-url/review-view'
      },
      {
        path: '/email-url/academic-agree',
        component: academicAgree,
        name: '/email-url/academic-agree'
      },
      // 外编查看
      {
        path: '/email-url/academic-agree/detail',
        component: academicAgree,
        name: '/email-url/academic-agree/detail'
      },
      {
        path: '/email-url/author-revise',
        component: authorRevise,
        name: '/email-url/author-revise'
      },
      {
        path: '/email-url/author-revise/reply',
        component: authorReviseReply,
        name: '/email-url/author-revise/reply'
      },
      // 失效页
      {
        path: '/email-url/invalid-page',
        component: invalidPage,
        name: '/email-url/invalid-page'
      },
      // 404
      // 失效页
      {
        path: '/email-url/404',
        component: page404,
        name: '/email-url/404'
      }
    ]
  }
]
